(function () {
	var initCardSliders = function(root) {
		var containers = (root || document).querySelectorAll('.swiper-container.product-card-js');
		containers.forEach(function(slider) {
			if (slider.classList.contains('swiper-initialized')) return;
			new Swiper(slider, {
				slidesPerView: 1,
				speed: 250,
				spaceBetween: 0,
				navigation: {
					nextEl: slider.querySelector('.swiper-button-next-1'),
					prevEl: slider.querySelector('.swiper-button-prev-1'),
				},
				pagination: {
					el: slider.querySelector('.product-card-pagination'),
					clickable: true,
				},
			});
		});
	};
	window.initCardSliders = initCardSliders;
	initCardSliders();
	document.addEventListener('shopify:section:load', function () {
		initCardSliders();
	});
})();
